import React from 'react';
import { Redirect, useRouteMatch } from 'react-router-dom';
import { useQuery } from 'react-apollo';

import { AlbumFolderForFaceRecognitionDisabled } from '../../../graphql/queries/album-folder';
import Spinner from '../../global/Spinner';

const AlbumFolderFaceRecognitionDisabled = () => {
  return WrappedComponent => props => {
    const match = useRouteMatch();
    const { albumFolderId } = match?.params ?? {};

    const { data: { albumFolder } = {}, loading } = useQuery(
      AlbumFolderForFaceRecognitionDisabled,
      {
        variables: {
          id: albumFolderId,
          include_roster_identity_data: false,
        },
        skip: !albumFolderId,
      },
    );

    if (loading) {
      return (
        <div className="wrapper-main min-h-100vh justify-content-center align-items-center">
          <Spinner />
        </div>
      );
    }

    if (!loading && !albumFolder) {
      return <Redirect to="/not-found" />;
    }

    if (albumFolder.face_recognition_disabled) {
      return (
        <Redirect to={`/discover/album-folder/${albumFolderId}/no-fr-join`} />
      );
    }

    return <WrappedComponent {...props} />;
  };
};

export default AlbumFolderFaceRecognitionDisabled;
